var Backbone, BrowseParsedParamsHelper, handlers, parsedParams;

Backbone = require('backbone');

parsedParams = new Backbone.Model();

handlers = {};

module.exports = BrowseParsedParamsHelper = {
  setParsedParams: function(params, options) {
    parsedParams.clear({
      silent: true
    });
    parsedParams.set(params, {
      silent: true
    });
    return parsedParams.trigger('change', parsedParams, options);
  },
  getParsedParams: function() {
    return parsedParams.toJSON();
  },
  onUpdate: function(cb, key) {
    var changeHandler;
    changeHandler = function(model, options) {
      return cb(model.toJSON(), options);
    };
    if (key != null) {
      handlers[key] = changeHandler;
    }
    return parsedParams.on('change', changeHandler);
  },
  offUpdate: function(key) {
    if (handlers[key]) {
      parsedParams.off('change', handlers[key]);
      return delete handlers[key];
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvaGVscGVycy9wYXJzZWRfcGFyYW1zLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvYnJvd3NlL2Zyb250ZW5kL2hlbHBlcnMvcGFyc2VkX3BhcmFtcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsWUFBQSxHQUFtQixJQUFBLFFBQVEsQ0FBQyxLQUFULENBQUE7O0FBQ25CLFFBQUEsR0FBVzs7QUFHWCxNQUFNLENBQUMsT0FBUCxHQUFpQix3QkFBQSxHQUNmO0VBQUEsZUFBQSxFQUFpQixTQUFDLE1BQUQsRUFBUyxPQUFUO0lBS2YsWUFBWSxDQUFDLEtBQWIsQ0FBbUI7TUFBRSxNQUFBLEVBQVEsSUFBVjtLQUFuQjtJQU9BLFlBQVksQ0FBQyxHQUFiLENBQWlCLE1BQWpCLEVBQXlCO01BQUUsTUFBQSxFQUFRLElBQVY7S0FBekI7V0FDQSxZQUFZLENBQUMsT0FBYixDQUFxQixRQUFyQixFQUErQixZQUEvQixFQUE2QyxPQUE3QztFQWJlLENBQWpCO0VBZUEsZUFBQSxFQUFpQixTQUFBO1dBQ2YsWUFBWSxDQUFDLE1BQWIsQ0FBQTtFQURlLENBZmpCO0VBa0JBLFFBQUEsRUFBVSxTQUFDLEVBQUQsRUFBSyxHQUFMO0FBQ1IsUUFBQTtJQUFBLGFBQUEsR0FBZ0IsU0FBQyxLQUFELEVBQVEsT0FBUjthQUNkLEVBQUEsQ0FBRyxLQUFLLENBQUMsTUFBTixDQUFBLENBQUgsRUFBbUIsT0FBbkI7SUFEYztJQUVoQixJQUFpQyxXQUFqQztNQUFBLFFBQVMsQ0FBQSxHQUFBLENBQVQsR0FBZ0IsY0FBaEI7O1dBQ0EsWUFBWSxDQUFDLEVBQWIsQ0FBZ0IsUUFBaEIsRUFBMEIsYUFBMUI7RUFKUSxDQWxCVjtFQXlCQSxTQUFBLEVBQVcsU0FBQyxHQUFEO0lBQ1QsSUFBRyxRQUFTLENBQUEsR0FBQSxDQUFaO01BQ0UsWUFBWSxDQUFDLEdBQWIsQ0FBaUIsUUFBakIsRUFBMkIsUUFBUyxDQUFBLEdBQUEsQ0FBcEM7YUFDQSxPQUFPLFFBQVMsQ0FBQSxHQUFBLEVBRmxCOztFQURTLENBekJYIn0=
